import styled from 'styled-components';
import { media } from '../../common/styles/styleUtil';

const Sarabun = 'Sarabun, Helvetica Neue, Helvetica, Arial, sans-serif';
export const CommentItemWrapper = styled.div`
  margin-top: 16px;
`;

export const CommentItemBody = styled.div`
  display: flex;
  justify-content: start;
  margin-bottom: 16px;
`;

export const CommentAvatar = styled.div`
  width: 36px;
  height: 36px;
  background-color: #d8d8d8;
  border-radius: 50%;
  border: 1px solid #979797;
  overflow: hidden;
  flex-shrink: 0;
  img {
    width: 100%;
    object-fit: fill;
  }
`;

export const ReplyButton = styled.span`
  text-decoration-line: underline;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const RightCommentContent = styled.div`
  width: 100%;
  max-width: 705px;
  margin-left: 8px;
  ${media.xs`
    max-width: 297px;
  `};
  .reply {
    height: auto;
    padding: 0;
    border: none !important;
    display: inline-block;
    color: #2b6ed2;
    font-size: 14px;
    font-weight: 500;
    margin: 0;
    text-transform: uppercase;
    line-height: normal;
  }
`;

export const CommentName = styled.p`
  color: #333f48;
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

export const CommentDate = styled.p`
  color: #697684;
  margin: 0 0 8px;
  font-size: 12px;
  font-weight: 300;
  line-height: normal;
`;

export const CommentMessage = styled.p`
  font-family: ${Sarabun};
  color: #333f48;
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
`;

export const SignedInUserWrapper = styled.div`
  margin-bottom: 10px;
`;
